export function i18nPlyr(code) {
  const languages = ['ru', 'en', 'ja'];

  const translations = {
    ru: {
      restart: 'Рестарт',
      rewind: 'Перемотать {seektime} секунд',
      play: 'Воспроизведение',
      pause: 'Пауза',
      fastForward: 'Вперед {seektime} секунд',
      seek: 'Seek',
      played: 'Проиграно',
      buffered: 'Буфферизация',
      currentTime: 'Текущее время',
      duration: 'Длительность',
      volume: 'Громкость',
      mute: 'Выключить звук',
      unmute: 'Включить звук',
      enableCaptions: 'Включить субтитры',
      disableCaptions: 'Выключить субтитры',
      enterFullscreen: 'Полный экран',
      exitFullscreen: 'Обычный размер',
      frameTitle: 'Player for {title}',
      captions: 'Субтитры',
      settings: 'Настройки',
      speed: 'Скорость',
      normal: 'Нормальная',
      quality: 'Качество',
      loop: 'Повтор',
      start: 'Старт',
      end: 'Конец',
      all: 'Все',
      reset: 'Сбросить',
      disabled: 'Выключено',
      enabled: 'Включено',
      advertisement: 'Реклама'
    },

    en: {
      restart: 'Restart',
      rewind: 'Rewind {seektime} secs',
      play: 'Play',
      pause: 'Pause',
      fastForward: 'Forward {seektime} secs',
      seek: 'Seek',
      played: 'Played',
      buffered: 'Buffered',
      currentTime: 'Current time',
      duration: 'Duration',
      volume: 'Volume',
      mute: 'Mute',
      unmute: 'Unmute',
      enableCaptions: 'Enable captions',
      disableCaptions: 'Disable captions',
      enterFullscreen: 'Fullscreen',
      exitFullscreen: 'Fullscreen off',
      frameTitle: 'Player for {title}',
      captions: 'Captions',
      settings: 'Settings',
      speed: 'Speed',
      normal: 'Normal',
      quality: 'Quality',
      loop: 'Loop',
      start: 'Start',
      end: 'End',
      all: 'All',
      reset: 'Reset',
      disabled: 'Disabled',
      enabled: 'Enabled',
      advertisement: 'Ad'
    },

    ja: {
      restart: '再起動',
      rewind: '{seektime} 秒巻き戻す',
      play: '遊ぶ',
      pause: '一時停止',
      fastForward: '{seektime}秒進む',
      seek: '求める',
      played: 'プレイした',
      buffered: '緩衝',
      currentTime: '現在の時刻',
      duration: '間隔',
      volume: '音量',
      mute: 'ミュート',
      unmute: 'Unmute',
      enableCaptions: '字幕を有効にする',
      disableCaptions: '字幕を無効にする',
      enterFullscreen: '全画面表示',
      exitFullscreen: '全画面表示を終了',
      frameTitle: '{title} のプレーヤー',
      captions: 'キャプション',
      settings: '設定',
      speed: 'スピード',
      normal: '普通',
      quality: '品質',
      loop: 'ループ',
      start: '始める',
      end: '終わり',
      all: '全て',
      reset: 'リセット',
      disabled: '無効',
      enabled: '有効',
      advertisement: '広告'
    }
  };

  if (code !== undefined && languages.includes(code)) {
    return translations[code];
  }

  return translations.en;
}
